import { render, staticRenderFns } from "./purchaseRequests.vue?vue&type=template&id=c52a2b1e&scoped=true"
import script from "./purchaseRequests.vue?vue&type=script&lang=js"
export * from "./purchaseRequests.vue?vue&type=script&lang=js"
import style0 from "./purchaseRequests.vue?vue&type=style&index=0&id=c52a2b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52a2b1e",
  null
  
)

export default component.exports